'use client';

import { c as _c } from "react/compiler-runtime";
import { toast } from 'sonner';
import { BetterTooltip } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
export function BranchBadge(t0) {
  const $ = _c(13);
  const {
    text,
    className
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = async () => {
      if (!navigator.clipboard?.writeText) {
        toast.error("Failed to copy branch name");
        return;
      }
      try {
        await navigator.clipboard.writeText(text);
        toast.info("Copied branch name");
      } catch {
        toast.error("Failed to copy branch name");
      }
    };
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("rounded-sm px-1.5 py-0.5 text-xs text-zinc-300 transition-colors hover:bg-zinc-800 hover:text-zinc-50 focus-visible:bg-zinc-800 focus-visible:text-zinc-50 active:bg-zinc-700", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleCopy) {
    t3 = () => void handleCopy();
    $[4] = handleCopy;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `Copy branch name ${text}`;
  let t5;
  if ($[6] !== text) {
    t5 = <code>{text}</code>;
    $[6] = text;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t5) {
    t6 = <BetterTooltip content="Copy branch name"><button type="button" className={t2} onClick={t3} aria-label={t4}>{t5}</button></BetterTooltip>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}